import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IHIMInventoryItem, IHIMInventoryList } from "../Infrastructure/Interfaces";
import axios from "axios";

const HIMInventoryListInitialState: IHIMInventoryList = {
    loading: true,
    HIMInventoryList: [],
  };

const ItemInitialState: IHIMInventoryItem = {
    WorkListInventoryId: 0,
    appealId: '',
    MRN: '',
    AccountNo: '',
    RegionCode: '',
    PlanType: '',
    HealthplanName: '',
    Remarks:'',
    CodeType: '',
    MD_NoOfpages: '',
    p_name: '',
    P_DOB: '',
    ClaimNumber: '',
    totalCharges: '',
    insuranceBalance: '',
    currentAccBalance: '',
    patientBalance: '',
    DeliveryOption: '',
    p_AdmitDate: '',
    p_DischargeDate: '',
    MergeFilePath: '',
    transactionState: '',
    workQueueInventoryStatus: '',
    LockedBy: '',
    ServiceType: '',
    nextDeliveryOption: '',
    TaskName: '',
    TaskNote: '',
    documents: '',
    Documentstobeincluded: '',
    DocumentLiseted: '',
    Coverletterpayer: '',
    TypeOfCoverLetter: '',
    InsurancePlan: '',
    MethodofDelivery: '',
    PortalName: '',
    PayerAddress: '',
    SendRecordsTo: '',
    ClaimFormRequired: '',
    CoverLetterCreatedby: '',
    DeadLine: '',
    EncounterClaimNo: '',
}

const HIMInventoryItemSlice = createSlice({
    name:'HIMInventoryItem',
    initialState:{value:ItemInitialState},
    reducers:{
        setHIMInventoryItem:(state,action)=>{
            state.value = action.payload
        }
    }
});

  
export const fetchHIMInventoryList = createAsyncThunk(
'fetchHIMInventoryList',
 async ({ userRole, regionCode }: { userRole: string; regionCode: string }, { rejectWithValue }) => {    
    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    const url = `${baseurl}/Him/Inventory/${userRole}/${regionCode}`;

    try {
        const tokenResponse = await axios.get(tokenurl);
        if (tokenResponse.data.success) {
          const validationResponse = await axios.get(url, {
            headers: {
              Pragma: 'no-cache',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          });
  
          if (validationResponse.data.success) {
            return validationResponse.data.result;
          } else {
            return rejectWithValue('Validation response unsuccessful');
          }
        } else {
            return rejectWithValue('Token response unsuccessful');
        }
      } catch (error:any) {
        console.error('Error fetching HIM Inventory List:', error);
        return rejectWithValue(error.message);
      }
    }
  );
  
  const HIMInventoryListSlice = createSlice({
    name: 'himinventorylist',
    initialState: HIMInventoryListInitialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchHIMInventoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.HIMInventoryList = action.payload;
      });
      builder.addCase(fetchHIMInventoryList.pending, (state, action) => {
        state.loading = true;
      });
      builder.addCase(fetchHIMInventoryList.rejected, (state, action) => {
        state.loading = false;
        state.HIMInventoryList = [];
      });
    },
  });


export const HIMInventoryListReducer = HIMInventoryListSlice.reducer;

export const {setHIMInventoryItem} = HIMInventoryItemSlice.actions;
  
export const HIMInventoryItemReducer = HIMInventoryItemSlice.reducer;